<template>
  <el-container>
    <el-aside class="aside">
      <add-sider v-model="clock" :data="slider" @on-add="addComponent"></add-sider>
    </el-aside>
    <Content class="c-content c-edit">
      <view-edit
        ref="viewedit"
        v-model="panel"
        :data="myArray"
        :attribute="compAttr"
        :current.sync="current"
        @on-add="editComponent"
        @on-change-groupbox="changeHandle"
      ></view-edit>
    </Content>
  </el-container>
</template>
<script>
import Cookies from 'js-cookie'
import { timeout, isArray } from '@/common/js/utils'
import slider from './data/slider'
import AddSider from './components/sider/add-sider'
import ViewEdit from './components/view/view-edit'
export default {
  name: 'pageLayout',
  components: {
    AddSider,
    ViewEdit
  },
  computed: {
    editState() {
      return this.$route.query.t === 'edit'
    },
    compAttr() {
      let attr = []
      if (this.myArray.length && this.current > -1) attr = this.myArray[this.current].attr
      return attr
    }
  },
  methods: {
    addComponent(component) {
      const newComponent = JSON.parse(JSON.stringify(component))
      this.myArray.push(newComponent)
      this.current = this.myArray.length - 1
      timeout(20).then(() => {
        this.$refs.viewedit.setCurrent(this.current)
        this.$refs.viewedit.scrollBottom()
      })
    },
    // 获取组件新增
    editComponent({ type, props }) {
      const components = this.slider.filter((ret) => ret.id === type)
      if (components.length && props) {
        const component = JSON.parse(JSON.stringify(components.pop()))
        for (const key in props) {
          const index = component.attr.findIndex((met) => met.name === key)
          if (index > -1) {
            const fieldObj = isArray(component.attr[index].children) && component.attr[index].children.length
            if (Object.prototype.toString.call(props[key]) === '[object Object]' && fieldObj) {
              for (const k in props[key]) {
                const idx = component.attr[index].children.findIndex((m) => m.name === k)
                component.attr[index].children[idx][k] = props[key][k]
              }
            } else if (key === 'image') {
              component.attr[index][key] = props[key]
              Object.assign(component.attr[index], { width: props.width, height: props.height })
            } else component.attr[index][key] = props[key]
          }
        }
        this.myArray.push(component)
      }
    },
    changeHandle({ name, value }) {
      if (name === 'btnstyle') {
        const alignIdx = this.compAttr.findIndex((ret) => ret.name === 'align')
        const imageIdx = this.compAttr.findIndex((ret) => ret.name === 'image')
        const bgimageIdx = this.compAttr.findIndex((ret) => ret.name === 'btn_bg_image')
        if (imageIdx > -1) {
          const rules = value === 'inline' ? '建议:240x80px' : '建议:750x120px'
          this.$set(this.compAttr[imageIdx], 'rules', rules)
          this.$set(this.compAttr[imageIdx], 'image', '')
          this.$set(this.compAttr[bgimageIdx], 'btn_bg_image', '')
        }
        alignIdx > -1 && this.$set(this.compAttr[alignIdx], 'align', 'center')
      }
    }
  },
  data() {
    return {
      panel: 'system',
      slider: slider, // 添加组件
      clock: 0, // 添加组件索引
      current: -1, // 设置组件索引
      myArray: [] // 组件数组
    }
  },
  created() {
    this.$store.commit('setToken', Cookies.get('ch_session_id'))
    this.opId = Cookies.get('ch_op_id')
    window.document.title = `${this.editState ? '编辑' : '新建'}平头哥落地页-天工开物`
  },
  watch: {
    compAttr(nVal) {
      const index = nVal.findIndex((ret) => ret.name === 'btnstyle')
      const alignIdx = nVal.findIndex((ret) => ret.name === 'align')
      const imageIdx = nVal.findIndex((ret) => ret.name === 'image')
      if (this.$route.query.id && index > -1 && alignIdx > -1 && imageIdx > -1) {
        nVal[index].btnstyle === 'inline' && this.$set(this.compAttr[imageIdx], 'rules', '建议:240x80px')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.aside {
  z-index: 9;
  background: #fff;
  width: 272px;
}

.c-edit {
  z-index: 6;
}

.c-switch {
  transition: all 0.4s;
}
</style>
